// Module
var code = "<div id=\"V-4902E328-D6B0-491A-B68B-3018F16AEC71\"> </div> ";
// Exports
export default code;